import "./GetInTouch.module.css";
import MainNavigation from "@/reusable_sections/Header";
import StartAConversation from "./sections/StartAConversation";
import CorporateFooter from "@/reusable_sections/Footer";
export default function GetInTouchPage() {
  return <div>
      <MainNavigation />
      <StartAConversation />
      <CorporateFooter />
    </div>;
}